// Export web components
export * from './views/main';
export * from './views/doc';
export * from './app';
import 'pdf.js-viewer-wc';
import '@futuri/futuri-ui-kit/dist/assets/topline.css';
